export const SET_DAY_PARTS = 'SET_DAY_PARTS'
export const SET_DATA_SOURCES = 'SET_DATA_SOURCES'
export const SET_AUDIENCE_SIZE = 'SET_AUDIENCE_SIZE'
export const SET_HISTORICAL_VIEWERSHIP = 'SET_HISTORICAL_VIEWERSHIP'
export const SET_UNIVERSE = 'SET_UNIVERSE'
export const SET_PREVIEW_TABLE_OPEN = 'SET_PREVIEW_TABLE_OPEN'

export default {
  [SET_DAY_PARTS] (state, value) {
    state.dayParts = value
  },
  [SET_DATA_SOURCES] (state, value) {
    state.dataSources = value
  },
  [SET_AUDIENCE_SIZE] (state, value) {
    state.audienceSize = value || 0
  },
  [SET_UNIVERSE] (state, value) {
    state.universe = value
  },
  [SET_HISTORICAL_VIEWERSHIP] (state, value) {
    state.historicalViewership = value
  },
  [SET_PREVIEW_TABLE_OPEN] (state, bool) {
    state.previewTableOpen = bool
  }
}



// WEBPACK FOOTER //
// ./src/app/views/workbench/AD/store/mutations.js